import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {Subscription} from 'rxjs';
import {HeaderService} from '../../core/services/header.service';
import {MenuModel} from '../../core/models/menu.model';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatNavList } from '@angular/material/list';
import { MatIconAnchor, MatAnchor, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatBadge } from '@angular/material/badge';

@Component({
    selector: 'app-new-side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.scss'],
    standalone: true,
    imports: [MatNavList, MatIconAnchor, MatIcon, NgIf, NgFor, MatAnchor, RouterLink, RouterLinkActive, MatTooltip, MatBadge, MatButton]
})
export class SideMenuComponent implements OnInit, OnDestroy {

  @Output() public sidenavClose = new EventEmitter();
  @Output() public sidenavOpen = new EventEmitter();

  sideMenuType = '';
  public menuItems = <MenuModel[]>[];
  public currentMenu: MenuModel;

  private currentMenuGroupSubscription: Subscription;
  private routerSubscription: Subscription;

  constructor(private authService: AuthService, private headerService: HeaderService, private router: Router) {

  }

  ngOnInit() {
    this.currentMenuGroupSubscription = this.headerService.currentMenu.subscribe((menu) => {
      this.currentMenu = menu;
      this.updateSideMenuVisibility(this.headerService.isMobileView.getValue());

      // FIXME this is workaround for side nave size because of animations
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 500);

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 1000);
    });

    this.headerService.isMobileView.subscribe(isMobileView => {
      this.updateSideMenuVisibility(isMobileView);
    });
  }

  updateSideMenuVisibility(isMobileView: boolean) {
    console.log('updateSideMenuVisibility: ', isMobileView);
    if (!this.currentMenu || this.currentMenu.subItems.length === 1) {
      this.sidenavClose.emit();
    } else {
      if (isMobileView) {
        this.sidenavClose.emit();
      } else {
        this.sidenavOpen.emit();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.currentMenuGroupSubscription) {
      this.currentMenuGroupSubscription?.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription?.unsubscribe();
    }
  }

  initMenu() {
    this.menuItems = this.headerService.getUserSideMenu();

    for (const menuItem of this.menuItems) {
      this.isCurrentRoute(menuItem);
    }
  }

  public isCurrentRoute(item: MenuModel): boolean {
    let isCurrent = this.router.url.startsWith(item.url);
    item.isCurrent = false;
    if (item.subItems && item.subItems.length > 1) {
      isCurrent = !!item.subItems.find(x => this.router.url.startsWith(x.url));
      item.isCurrent = isCurrent;
      if (isCurrent) {
        item.toggle = isCurrent;
      }
    }

    return isCurrent;
  }

  onCloseSidenav() {
    this.sidenavClose.emit(true);
  }

  getTooltipText(menuItem: MenuModel): string {
    if(menuItem.description) {
      return `${menuItem.title} - ${menuItem.description}`
    }

    return menuItem.title;
  }
}
